import React from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	titleBlock: {
		minWidth: 240,
		maxWidth: 620
	},
	title: {
		color: theme.palette.text.primary,
		fontWeight: 700,
		lineHeight: 1.25
	},
	description: {
		color: theme.palette.text.secondary,
		fontSize: 13,
		marginTop: theme.spacing(0.25)
	}
}));

export default function Title({ children, description }) {
	const classes = useStyles();

	return (
		<div className={classes.titleBlock}>
			<Typography variant="h5" className={classes.title}>
				{children}
			</Typography>
			{description && (
				<Typography className={classes.description}>
					{description}
				</Typography>
			)}
		</div>
	);
}
